<template>
  <div class="mt-3">
    <div :class="styletable.row">
      <div :class="styletable.col1">Insurance</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        <p>{{ name }}</p>
      </div>
    </div>

    <div :class="styletable.row" v-if="typeRequest === 'Contract'">
      <div :class="styletable.col1">Estimate Contract Value</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ custDetail.estimate_contract_value || '-' }}
      </div>
    </div>

    <div :class="styletable.row">
      <div :class="styletable.col1">Addition Service</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        <b-form-checkbox
          id="checkbox-1"
          v-model="consigneeUndername"
          name="checkbox-1"
          value="true"
          unchecked-value="false"
          disabled="true"
        >
          Consignee Undername </b-form-checkbox
        ><b-form-checkbox
          id="checkbox-2"
          v-model="shipperUndername"
          name="checkbox-2"
          value="true"
          unchecked-value="false"
          disabled="true"
        >
          Shipper Undername
        </b-form-checkbox>
        <b-form-checkbox
          id="checkbox-3"
          v-model="warehouse"
          name="checkbox-3"
          value="true"
          unchecked-value="false"
          disabled="true"
        >
          Warehouse
        </b-form-checkbox>
      </div>
    </div>

    <div :class="styletable.row">
      <div :class="styletable.col1">Remarks</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ custDetail.note_for_merchant || '-' }}
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/mixin/getters/shipment-details'
import { mapGetters } from 'vuex'

export default {
  name: 'AddressDetails',
  props: {
    typeRequest: String,
    custDetail: Object,
    isLoading: Boolean
  },
  mixins: [mixin],
  data() {
    return {
      styletable: {
        row: 'row m-0 mb-1',
        col1: 'col-md-4 pl-0',
        col2: 'col-md pl-1 textcolor textbold',
        col3: 'col-md-0'
      },
      name: 'None',
      warehouse: '',
      consigneeUndername: '',
      shipperUndername: ''
    }
  },

  computed: {
    ...mapGetters({
      insuranceOption: 'insurance/insuranceList',
      isLoadingInsuranceList: 'insurance/isLoadingInsuranceList'
    }),
    getInsurace() {
      return { ...this.insuranceOption, ...this.custDetail }
    },
    dataInsurance() {
      return this.insuranceOption
    }
  },
  mounted() {
    this.$store.dispatch('insurance/INSURANCE_LIST')
    this.warehouse = this.custDetail.warehouse
    this.consigneeUndername = this.custDetail.consignee_undername
    this.shipperUndername = this.custDetail.shipper_undername
  },
  watch: {
    dataInsurance(data) {
      if (
        this.custDetail.id_insurance === 1 ||
        this.custDetail.id_insurance === 2
      ) {
        data.forEach(element => {
          if (element.id === this.custDetail.id_insurance) {
            this.name = element.name
          }
        })
      } else if (
        this.custDetail.id_insurance === 3 ||
        this.custDetail.id_insurance === null
      ) {
        if (
          this.custDetail.option_insurance === '1' ||
          this.custDetail.option_insurance === true
        ) {
          this.name = data[0].name
        } else {
          this.name = 'None'
        }
      } else {
        this.name = 'None'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/tabs-detail/Others.vue